import dayjs from 'dayjs';

import type { Schema } from '../../../../../types/DirectusSchema';
import type { FormData } from '../types/FormData.ts';
import { parseEventType } from './lib/parseEventType.ts';
import { parseRecurrenceRate } from './lib/parseRecurrenceRate.ts';

export const apiToForm = (data: Schema['incomplete_events'][0]): FormData => {
  return {
    id: data.id,
    name: data.name ?? '',
    category: typeof data.category === 'object' && data.category?.id ? data.category.id.toString(10) : '',
    tags:
      data?.target_audiences?.map((item) =>
        typeof item === 'string'
          ? ''
          : typeof item?.target_audiences_id === 'object' && item.target_audiences_id !== null
            ? item.target_audiences_id.id.toString(10)
            : (item?.target_audiences_id ?? ''),
      ) ?? [],
    description: (data.description ?? {}) as FormData['description'],
    websiteLink: data.website_link ?? '',
    instagramLink: data.instagram_link ?? '',
    tiktokLink: data.tiktok_link ?? '',
    eventType: parseEventType(data.type),
    venue: typeof data.venue === 'object' && data.venue?.id ? data.venue.id.toString(10) : '',
    onlineLink: data.online_link ?? '',
    image: typeof data.image === 'string' ? data.image : '',
    spotifyLink: data.spotify_link ?? '',
    start: data.start ? dayjs(data.start).toDate() : new Date(),
    end: data.end ? dayjs(data.end).toDate() : new Date(),
    recurrenceRate: parseRecurrenceRate(data.recurrence_rate),
    recurrenceActive: data.recurrence_active ?? false,
    recurrenceAmount: ((data as unknown as Record<string, unknown>).recurrence_amount as number) ?? null,
    recurrenceMonthType:
      ((data as unknown as Record<string, unknown>).recurrence_month_type as string) ?? 'nth-weekday-of-month',
    recurrenceDurationOption:
      ((data as unknown as Record<string, unknown>).recurrence_duration_option as string) ?? 'one-month',
    ticketshopLink: data.ticket_sale_url ?? '',
    eventDetails:
      data?.event_details?.map((item) =>
        typeof item === 'string'
          ? ''
          : typeof item?.event_details_id === 'object' && item.event_details_id !== null
            ? item.event_details_id.id.toString(10)
            : (item?.event_details_id ?? ''),
      ) ?? [],
  };
};
